import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import DocumentsNavigationIcon from 'Icons/NavigationItem/Documents';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyDocumentsSettingsPage = React.lazy(() => import('./Pages'));

const documentsSettingsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.documents.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.documents.title',
            url: '/documents-settings',
            Icon: DocumentsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyDocumentsSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default documentsSettingsConfiguration;
